export type AccessUrl = { kind: 'domain'; domainId: number } | { kind: 'org'; orgId: number } | { kind: 'none' }

const DOMAIN_PREFIX = /^\/domains\/([1-9]\d*)(?:\/|$)/
const ORG_PREFIX = /^\/organizations\/([1-9]\d*)(?:\/|$)/

const toId = (digits: string): number | undefined => {
    const id = Number(digits)
    return Number.isSafeInteger(id) ? id : undefined
}

/**
 * The one parser for the access context named by a URL path. Both patterns are anchored at the
 * start of the path, so `/x/domains/5` names nothing. A query string or hash is ignored. When the
 * path could be read as both, the domain wins.
 */
export function parseAccessUrl(pathname: string): AccessUrl {
    const path = pathname.split(/[?#]/, 1)[0]

    const domainMatch = DOMAIN_PREFIX.exec(path)
    const domainId = domainMatch ? toId(domainMatch[1]) : undefined
    if (domainId !== undefined) {
        return { kind: 'domain', domainId }
    }

    const orgMatch = ORG_PREFIX.exec(path)
    const orgId = orgMatch ? toId(orgMatch[1]) : undefined
    if (orgId !== undefined) {
        return { kind: 'org', orgId }
    }

    return { kind: 'none' }
}
